import * as tslib_1 from "tslib";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { Component } from "vue-property-decorator";
import RelevanceFormDropdown from "./relevance-form-dropdown.vue";
import RelevanceFormModal from "./relevance-form-modal.vue";
let RelevanceFormMulti = class RelevanceFormMulti extends RelevanceFormControl {
    onClick(id) {
        this.open(id);
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //展示字段需取数据项列表中的relativePropertyCode;
            // let ls = await this.getRelativeDataList();
            // let dataModal: any = ls.find((c: any) => c.code === this.control.key);
            let dataModal = this.getDataItem(this.control.key, this.control.parentKey);
            if (!dataModal) {
                // 兼容列表查询条件没有传入DataItem。且查询条件只是存在主表；
                let ls = yield this.getRelativeDataList(true);
                dataModal = ls.find((c) => c.code === this.control.key);
            }
            //覆盖数据项options中的displayField（表单设计中的displayField，若在数据模型中重新定义一次后，会导致与后台的展示字段对应不上，所以直接拿后台的展示字段即可）
            this.control.options.displayField = dataModal && dataModal.relativePropertyCode
                ? dataModal.relativePropertyCode
                : "name";
        });
    }
    get ids() {
        if (Array.isArray(this.ctrl.value) && this.ctrl.value.length > 0) {
            return this.ctrl.value.map(item => item.id).join(";");
        }
        else {
            if (this.ctrl.value) {
                return this.ctrl.value.id;
            }
            else {
                return "";
            }
        }
    }
    get names() {
        let field = this.ctrl.value.displayCode || this.getDisplayField;
        if (Array.isArray(this.ctrl.value) && this.ctrl.value.length > 0) {
            return this.ctrl.value.map(item => this.parseDisplayFieldValue(item[field] ? item[field] : "空", field)).join(";");
        }
        else {
            if (this.ctrl.value) {
                let tmp = this.ctrl.value[field];
                if (tmp) {
                    return tmp.split(";").map(item => item ? this.parseDisplayFieldValue(item, field) : "空").join(";");
                }
                else {
                    return tmp ? tmp : "空";
                }
            }
            else {
                return "";
            }
        }
    }
};
RelevanceFormMulti = tslib_1.__decorate([
    Component({
        name: "relevance-form",
        components: {
            RelevanceFormDropdown,
            RelevanceFormModal
        }
    })
], RelevanceFormMulti);
export default RelevanceFormMulti;
